import { Controller } from 'stimulus';

class VacanciesSearchFormController extends Controller {
  connect() {
    this.handleVacanciesCount();
  }

  onTypeFilterChange() {
    this.handleVacanciesCount();
  }

  getSelectedTypeFilter() {
    const checked = this.vacanciesTypeFilterTargets
      .filter((checkboxElement) => checkboxElement.checked);

    return checked.length ? checked[0] : null;
  }

  handleVacanciesCount() {
    const selectedTypeFilter = this.getSelectedTypeFilter();

    if (selectedTypeFilter.value?.toLowerCase() === 'intern') {
      this.vacanciesCountTarget.style.display = 'none';
      this.internVacanciesCountTarget.style.display = 'block';
    } else {
      this.vacanciesCountTarget.style.display = 'block';
      this.internVacanciesCountTarget.style.display = 'none';
    }
  }
}

VacanciesSearchFormController.targets = [
  'vacanciesCount',
  'internVacanciesCount',
  'vacanciesTypeFilter',
];

export default VacanciesSearchFormController;
